<template>
  <div>
    <p
      v-if="timeAnswer > 0 && timeToAnswer > 0 && timeAnswer < timeToAnswer"
      class="time-answer__text"
    >
      <span
        v-html="
          $t('youAnsweredIn', {
            msg: '<strong>' + getTimeCount(timeAnswer) +'</strong>',
            num: getTimeCount(derivedTimeLeft)
          })
        "
      />
      <br><span>{{ $t("waitAndSeeHowYouDid") }}</span>
    </p>
    <p v-else class="time-answer__text">
      {{ $t("runOutOfTime") }}
    </p>
  </div>
</template>

<script>
import Utils from '@/util'

export default {
  props: {
    timeAnswer: {
      type: Number,
      default: 0,
    },
    timeToAnswer: {
      type: Number,
      default: 0,
    },
    timeLeft: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    derivedTimeLeft() {
      if (this.timeAnswer < this.timeToAnswer && this.timeAnswer > 0) {
        return this.timeToAnswer - this.timeAnswer
      }
      return this.timeLeft
    },
  },
  methods: {
    getTimeCount(second) {
      return Utils.getTimeCount(second, this)
    },
  },
}
</script>

<style lang="scss" scoped>
.time-answer__text {
  font-size: 14px;
  line-height: 18px;
}
</style>
